import React from 'react';
import { Link } from 'react-router-dom';
import { Database, ArrowRight } from 'lucide-react';
import { PageHeader } from '../components/PageHeader';
import { ReportEmbed } from '../components/ReportEmbed';


export function ReportsPage() {
  return (
    <div className="pb-12">
      <PageHeader
        eyebrow="Library"
        title="All Reports"
        description="Every Power BI artifact published to the IMAGE-I workspace."
      />
      <div className="px-6 lg:px-10 mt-2">
        <Link
          to="/imagei/activity-report"
          className="surface-card mb-4 flex items-center justify-between gap-4 p-5 transition hover:border-primary/50 hover:shadow-sm"
        >
          <div className="flex items-center gap-4">
            <div className="flex h-11 w-11 items-center justify-center rounded-lg bg-primary/10 text-primary">
              <Database className="h-5 w-5" />
            </div>
            <div>
              <p className="text-sm font-semibold text-foreground">Activity Table Report</p>
              <p className="mt-1 text-xs text-muted-foreground">
                MTD, QTD, YTD and FY report generated from your activity table data.
              </p>
            </div>
          </div>
          <ArrowRight className="h-4 w-4 shrink-0 text-muted-foreground" />
        </Link>
        <ReportEmbed
          subtitle="Embedded reports allocated to your account across all departments"
        />
      </div>
    </div>
  );
}
